import { MoveGenerator } from '../../jscaip/AI/AI';
import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { CoerceoRegularMove, CoerceoTileExchangeMove } from './CoerceoMove';
export class CoerceoMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        let moves = this.getListExchanges(node);
        moves = moves.concat(this.getListMovement(node));
        return moves;
    }
    getListExchanges(node) {
        const state = node.gameState;
        const player = state.getCurrentPlayer();
        const opponent = FourStatePiece.ofPlayer(state.getCurrentOpponent());
        if (state.tiles.get(player) < 2) {
            return [];
        }
        const exchanges = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            if (coordAndContent.content === opponent) {
                const move = CoerceoTileExchangeMove.of(coordAndContent.coord);
                exchanges.push(move);
            }
        }
        return exchanges;
    }
    getListMovement(node) {
        const movements = [];
        const state = node.gameState;
        const player = state.getCurrentPlayer();
        for (const coordAndContent of state.getCoordsAndContents()) {
            const start = coordAndContent.coord;
            if (coordAndContent.content.is(player)) {
                const legalLandings = state.getLegalLandings(start);
                for (const end of legalLandings) {
                    const move = CoerceoRegularMove.of(start, end);
                    movements.push(move);
                }
            }
        }
        return movements;
    }
}
